module.exports = __webpack_public_path__ + "assets/997d37066e919cb0e441783a7720b9de.mp3";